import React from "react";

import Button from "elements/Button";

import NotFound from "assets/images/NotFound.png";

export default function NotFoundPage() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-maroon-950 px-4">
      <img src={NotFound} alt="Page not found" loading="lazy" className="sm:w-3/4 xl:w-5/12" />
      <h1 className="mt-5 text-center text-2xl text-white">
        You weren&apos;t supposed to find this place...
      </h1>
      <Button
        href="/"
        type="link"
        className="mt-6 flex items-center rounded-lg bg-gold-500 px-6 py-2.5 font-semibold text-maroon-950 transition-colors hover:bg-gold-400"
      >
        Go Back Home
      </Button>
    </div>
  );
}
